<template>
  <div class="flex flex-col items-center justify-between h-screen">
    <div class="flex flex-col justify-center text-center h-3/4">
      <i class="material-icons text-primary text-6xl">done_all</i>
      <h1 class="text-2xl text-gray-500 font-thin">
        Carpe Diem
      </h1>
    </div>
    <div
      class="flex flex-col w-full justify-center items-center h-1/4 p-10"
      :class="{ 'pt-10 pb-2 justify-between': iOS && !standalone }"
    >
      <t-button @click="login">
        Login with Google
      </t-button>

      <div
        v-if="iOS && !standalone"
        class="flex flex-col justify-center text-center text-gray-500"
      >
        <p class="text-xs">Add to Home Screen</p>
        <i class="material-icons">arrow_downward</i>
      </div>

      <div v-else>
        <p class="text-gray-500 text-xs mt-6">
          Crafted with ♥ in the EU by
          <a
            href="https://james.vodang.com"
            target="_blank"
            class="text-primary"
            >James Vodang</a
          >
        </p>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  name: 'Login',
  computed: {
    loggedIn() {
      return this.$store.state.loggedIn
    },

    standalone() {
      return window.matchMedia('(display-mode: standalone)').matches
    },

    iOS() {
      return (
        [
          'iPad Simulator',
          'iPhone Simulator',
          'iPod Simulator',
          'iPad',
          'iPhone',
          'iPod'
        ].includes(navigator.platform) ||
        (navigator.userAgent.includes('Mac') && 'ontouchend' in document)
      )
    }
  },

  methods: {
    login() {
      this.$store.dispatch('login')
    }
  }
}
</script>
<style lang="scss" scoped>
.h-1\/4 {
  height: 25%;
}
.h-3\/4 {
  height: 75%;
}
.pt-10 {
  padding: 2.5rem;
}
.pb-2 {
  padding-bottom: 0.5rem;
}
</style>
